
import resetPassword from '~/graphql/mutations/auth/resetPassword.gql';

export default {
  layout: 'login',
  middleware: 'guest',
  auth: false,
  data: () => ({
    formName: 'changePassword',
    form: {
      email: '',
      token: '',
      password: '',
      password_confirmation: '',
    },
  }),
  created() {
    if (!this.$route.query.token && !this.$route.query.email) {
      this.$router.push(this.localePath({name: 'index'}));
    }

    this.form.email = this.$route.query.email;
    this.form.token = this.$route.query.token;
  },
  methods: {
    async submit() {
      try {
        const {data: {resetPassword: passwordResult}} = await this.$apollo.mutate({
          mutation: resetPassword,
          variables: this.form,
        });

        if (!passwordResult) {
          throw new Error('Failed to reset password');
        }

        this.$toast.success('Uw wachtwoord is opnieuw ingesteld.');
        await this.$router.push(this.localePath({name: 'auth-inloggen'}));
      } catch (e) {
        this.$formulate.handle(e, this.formName);
      }
    },
  },
};
